<div data-testid="stock-change-page" class="p-6 flex-table-page">
  <!-- Page Header -->
  <h2 class="text-2xl font-semibold text-gray-800 mb-3 flex-table-header">
    {{ "inventory_change_lookup.title" | translate }}
  </h2>

  <!-- Search Form -->
  <app-search-form
    data-testid="stock-change-search-form"
    [searchFormat]="searchFormat"
    (formSearch)="onSearch($event)"
    (formReset)="onReset()"
  >
    <div slot="actions" class="flex gap-2">
      <app-button
        [testId]="'stock-change-column-config-btn'"
        type="success"
        [outlined]="true"
        icon="view_column"
        (emitOnClick)="onColumnConfigClick($event)"
      ></app-button>
    </div>
  </app-search-form>

  <!-- Data Table -->
  <div class="table-section flex-table-section">
    <advanced-data-table
      data-testid="stock-change-table"
      #advancedTable
      [dataSource]="dataSource()"
      [defaultColumns]="defaultColumns()"
      [flexibleColumns]="flexibleColumns()"
      [referenceColumnOrder]="referenceColumnOrder()"
      [loading]="loading()"
      [rows]="rows()"
      [first]="first()"
      [totalRecords]="totalRecords()"
      scrollHeight="flex"
      [showInternalColumnConfigButton]="false"
      class="w-full"
      (pageChange)="onPageChange($event)"
    >
    </advanced-data-table>
  </div>
</div>
